<div class="modal-header">
    <h4 class="modal-title text-center">Search VRM</h4>
    <img class="modal-close" (click)="dismissModal()" alt="Close">
</div>
<div class="modal-body">
    <app-search-vrm [dataEntryOnly]="true" (vrm)="enterVrm($event)"></app-search-vrm>
</div>